import CoordGeoConfig from './_config/coord.geo.config';
import CoordGeoFormController from './components/coord-geo-form';

const moduleName = 'app.massia.common.coord.geo';

angular.module(moduleName, []).config(CoordGeoConfig).component('coordGeo', CoordGeoFormController);

export default moduleName;
